export function doNothing() {
  /*
        This is useful when we want to be explicit about some callback (e.g onRequestClose) but we
        want to ignore it.
    */
}
